import { useSyncExternalStore } from 'react'
import { RoomStateX } from '../../../types/mfc'
import { getRoomState } from '../../app-state/state.room'
import { getActiveRooms } from '../../mfcLogic/rooms'
import { subRoom } from './useRoomAppState'

export const useRoomsAppState = (): RoomStateX => {
    return useSyncExternalStore(subRoom, getRoomState, getRoomState)
}

const getRoomsCount = () => getActiveRooms(getRoomState()).length

export const useRoomsCount = (): number => {
    return useSyncExternalStore(subRoom, getRoomsCount, getRoomsCount)
}
